module.exports = __webpack_public_path__ + "img/p-35.e48ed499.png";